import React from 'react';

import PropTypes from 'prop-types';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { CustomModal } from 'components/CustomModal';

const getParticipantDisplayName = (participant) => {
  const name = `${participant?.firstName || participant?.vorname || ''} ${
    participant?.lastName || participant?.nachname || ''
  }`.trim();

  return name || '-';
};

export const EventRegisterRemoveParticipantModal = ({
  participant,
  isOpen,
  isRemoving,
  onConfirm,
  onClose,
}) => {
  const participantName = getParticipantDisplayName(participant);

  return (
    <CustomModal
      title="Teilnehmer abmelden"
      content={
        <div>Möchten Sie die Fachkraft {participantName} von der Veranstaltung abmelden?</div>
      }
      ctaButtons={
        <>
          <ActionButton onClick={onConfirm} title="Ja" inverted disabled={isRemoving} />
          <ActionButton onClick={onClose} title="Nein" inverted disabled={isRemoving} />
        </>
      }
      closeCancelEventModal={onClose}
      isOpen={isOpen}
    />
  );
};

EventRegisterRemoveParticipantModal.propTypes = {
  participant: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    vorname: PropTypes.string,
    nachname: PropTypes.string,
  }),
  isOpen: PropTypes.bool.isRequired,
  isRemoving: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

EventRegisterRemoveParticipantModal.defaultProps = {
  participant: null,
};
